// ZCTA populations for the Map Lab per-capita view.
// Real US Census 2020 Decennial P1_001N (total population) per ZCTA.
// Generated by backend/scripts/generate_zcta_population.py
export const ZCTA_POPULATION = {
  "85003": 11042,
  "85004": 8833,
  "85006": 23797,
  "85007": 14442,
  "85008": 59047,
  "85009": 50439,
  "85012": 8201,
  "85013": 21970,
  "85014": 26381,
  "85015": 41436,
  "85016": 37326,
  "85017": 45279,
  "85018": 37944,
  "85019": 27677,
  "85020": 34534,
  "85021": 40943,
  "85022": 51314,
  "85023": 35241,
  "85024": 26021,
  "85026": 0,
  "85027": 38343,
  "85028": 19888,
  "85029": 47101,
  "85031": 31162,
  "85032": 68710,
  "85033": 57980,
  "85034": 5033,
  "85035": 51441,
  "85037": 50929,
  "85040": 33993,
  "85041": 64639,
  "85042": 45433,
  "85043": 35800,
  "85044": 39559,
  "85045": 8090,
  "85048": 34524,
  "85050": 31591,
  "85051": 46123,
  "85053": 30136,
  "85054": 8849,
  "85083": 20898,
  "85085": 27875,
  "85086": 43223,
  "85087": 9853,
  "85118": 13044,
  "85119": 22069,
  "85120": 30605,
  "85121": 2802,
  "85122": 55063,
  "85123": 9965,
  "85128": 15764,
  "85131": 16723,
  "85132": 38848,
  "85135": 519,
  "85137": 2021,
  "85138": 46914,
  "85139": 18137,
  "85140": 45381,
  "85141": 416,
  "85142": 80734,
  "85143": 41720,
  "85145": 2572,
  "85147": 5390,
  "85172": 1132,
  "85173": 2458,
  "85191": 187,
  "85192": 1367,
  "85193": 4450,
  "85194": 7592,
  "85201": 51187,
  "85202": 39626,
  "85203": 37962,
  "85204": 63808,
  "85205": 44137,
  "85206": 36713,
  "85207": 50108,
  "85208": 36820,
  "85209": 44192,
  "85210": 40351,
  "85212": 48422,
  "85213": 36572,
  "85215": 16461,
  "85224": 46919,
  "85225": 73551,
  "85226": 40689,
  "85233": 39006,
  "85234": 51051,
  "85236": 42,
  "85248": 38567,
  "85249": 47414,
  "85250": 16501,
  "85251": 40073,
  "85253": 17358,
  "85254": 46352,
  "85255": 44976,
  "85256": 4857,
  "85257": 29187,
  "85258": 25203,
  "85259": 22548,
  "85260": 37967,
  "85262": 13366,
  "85263": 3382,
  "85264": 1421,
  "85266": 11971,
  "85268": 24031,
  "85281": 69218,
  "85282": 52351,
  "85283": 45736,
  "85284": 18638,
  "85286": 49407,
  "85295": 51587,
  "85296": 50418,
  "85297": 36076,
  "85298": 41816,
  "85301": 67380,
  "85302": 41369,
  "85303": 34252,
  "85304": 28125,
  "85305": 14055,
  "85306": 25663,
  "85307": 10742,
  "85308": 66540,
  "85309": 985,
  "85310": 19315,
  "85320": 800,
  "85321": 3663,
  "85322": 585,
  "85323": 44632,
  "85324": 2720,
  "85325": 847,
  "85326": 72959,
  "85328": 208,
  "85329": 2438,
  "85331": 31038,
  "85332": 1912,
  "85333": 428,
  "85334": 775,
  "85335": 35815,
  "85336": 7810,
  "85337": 2473,
  "85338": 59313,
  "85339": 50447,
  "85340": 33778,
  "85341": 18,
  "85342": 1478,
  "85343": 164,
  "85344": 9137,
  "85345": 61024,
  "85346": 2803,
  "85347": 310,
  "85348": 2083,
  "85349": 28039,
  "85350": 18486,
  "85351": 29795,
  "85352": 388,
  "85353": 42936,
  "85354": 7200,
  "85355": 12930,
  "85356": 3487,
  "85357": 438,
  "85360": 222,
  "85361": 6954,
  "85362": 569,
  "85363": 7056,
  "85364": 73550,
  "85365": 50166,
  "85367": 21303,
  "85371": 266,
  "85373": 19629,
  "85374": 41182,
  "85375": 27944,
  "85377": 3515,
  "85378": 9368,
  "85379": 49441,
  "85381": 27008,
  "85382": 42576,
  "85383": 69617,
  "85387": 16331,
  "85388": 30611,
  "85390": 9102,
  "85392": 40363,
  "85395": 37157,
  "85396": 32990,
  "85501": 12473,
  "85530": 2104,
  "85531": 761,
  "85532": 412,
  "85533": 2949,
  "85534": 2522,
  "85535": 28,
  "85536": 369,
  "85539": 3618,
  "85540": 4026,
  "85541": 22974,
  "85542": 3172,
  "85543": 4283,
  "85544": 2905,
  "85545": 523,
  "85546": 20100,
  "85550": 4934,
  "85551": 396,
  "85552": 6887,
  "85553": 1491,
  "85554": 735,
  "85601": 644,
  "85602": 10198,
  "85603": 6342,
  "85605": 629,
  "85606": 977,
  "85607": 17738,
  "85608": 1983,
  "85609": 325,
  "85610": 1053,
  "85611": 1017,
  "85613": 5239,
  "85614": 25789,
  "85615": 9073,
  "85616": 5110,
  "85617": 1086,
  "85618": 1271,
  "85619": 113,
  "85620": 734,
  "85621": 21730,
  "85622": 6583,
  "85623": 4974,
  "85624": 1222,
  "85625": 1871,
  "85626": 1006,
  "85627": 472,
  "85629": 29824,
  "85630": 2585,
  "85631": 3179,
  "85632": 812,
  "85633": 51,
  "85634": 5864,
  "85635": 35095,
  "85637": 1264,
  "85638": 1886,
  "85639": 240,
  "85640": 339,
  "85641": 29538,
  "85643": 8208,
  "85645": 1917,
  "85646": 1653,
  "85648": 20720,
  "85650": 14857,
  "85653": 19885,
  "85654": 94,
  "85658": 15791,
  "85701": 5132,
  "85704": 34430,
  "85705": 56711,
  "85706": 54853,
  "85707": 734,
  "85708": 3837,
  "85709": 0,
  "85710": 57381,
  "85711": 41518,
  "85712": 33108,
  "85713": 46810,
  "85714": 14232,
  "85715": 18561,
  "85716": 31521,
  "85718": 28706,
  "85719": 46242,
  "85721": 0,
  "85723": 132,
  "85724": 0,
  "85726": 11,
  "85730": 39258,
  "85734": 4855,
  "85735": 10522,
  "85736": 4569,
  "85737": 22212,
  "85739": 18878,
  "85741": 34131,
  "85742": 30057,
  "85743": 30441,
  "85745": 36774,
  "85746": 43278,
  "85747": 27703,
  "85748": 18816,
  "85749": 19009,
  "85750": 25007,
  "85755": 18277,
  "85756": 35345,
  "85757": 21712,
  "85901": 18701,
  "85902": 16,
  "85911": 1915,
  "85912": 269,
  "85920": 677,
  "85922": 68,
  "85923": 499,
  "85924": 2851,
  "85925": 4332,
  "85926": 435,
  "85927": 176,
  "85928": 752,
  "85929": 8040,
  "85930": 1122,
  "85931": 178,
  "85932": 481,
  "85933": 3639,
  "85934": 601,
  "85935": 3945,
  "85936": 4217,
  "85937": 8434,
  "85938": 2100,
  "85939": 4213,
  "85940": 1580,
  "85941": 10575,
  "85942": 64,
  "86001": 37093,
  "86003": 113,
  "86004": 38451,
  "86005": 16343,
  "86011": 3499,
  "86015": 1186,
  "86016": 59,
  "86017": 1131,
  "86018": 1121,
  "86020": 1852,
  "86021": 4133,
  "86022": 2058,
  "86023": 2420,
  "86024": 643,
  "86025": 5358,
  "86028": 34,
  "86029": 178,
  "86030": 1037,
  "86031": 1705,
  "86032": 1411,
  "86033": 7734,
  "86034": 2116,
  "86035": 1694,
  "86036": 195,
  "86038": 117,
  "86039": 1438,
  "86040": 10179,
  "86042": 1493,
  "86043": 1559,
  "86044": 4127,
  "86045": 10445,
  "86046": 6310,
  "86047": 14168,
  "86052": 40,
  "86053": 2025,
  "86054": 1841,
  "86301": 25115,
  "86303": 18201,
  "86305": 19555,
  "86313": 92,
  "86314": 39461,
  "86315": 10354,
  "86320": 2111,
  "86321": 2234,
  "86322": 12696,
  "86323": 18422,
  "86324": 4544,
  "86325": 5472,
  "86326": 24465,
  "86327": 11530,
  "86329": 1288,
  "86331": 515,
  "86332": 1716,
  "86333": 5886,
  "86334": 5261,
  "86335": 5229,
  "86336": 11125,
  "86337": 1312,
  "86338": 587,
  "86343": 88,
  "86351": 6398,
  "86401": 27684,
  "86403": 17787,
  "86404": 18312,
  "86406": 24935,
  "86409": 28860,
  "86411": 202,
  "86413": 13436,
  "86426": 15953,
  "86429": 7708,
  "86431": 417,
  "86432": 3158,
  "86433": 127,
  "86434": 1424,
  "86435": 224,
  "86436": 1938,
  "86437": 92,
  "86438": 945,
  "86440": 7310,
  "86441": 1919,
  "86442": 34171,
  "86443": 16,
  "86444": 1491,
  "86445": 354,
  "86502": 1032,
  "86503": 9851,
  "86504": 5723,
  "86505": 6605,
  "86506": 1415,
  "86507": 1912,
  "86508": 606,
  "86510": 4815,
  "86511": 3603,
  "86512": 2146,
  "86514": 2399,
  "86515": 3634,
  "86520": 2361,
  "86535": 1051,
  "86538": 2355,
  "86540": 1099,
  "86544": 1060,
  "86545": 1414,
  "86547": 1094,
  "86556": 2398,
};
